import { render, staticRenderFns } from "./driverDetial.vue?vue&type=template&id=29e8da70&scoped=true&"
import script from "./driverDetial.vue?vue&type=script&lang=js&"
export * from "./driverDetial.vue?vue&type=script&lang=js&"
import style0 from "./driverDetial.vue?vue&type=style&index=0&id=29e8da70&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e8da70",
  null
  
)

export default component.exports